import { useCallback, useEffect, useRef } from "react";

export default function useClickOutside<T>(callback: () => void) {
    const ref = useRef<T>(null);

    const clickHandler = useCallback((e: MouseEvent) => {
        if (!ref.current) return;
        if (
            isChildOf(
                e.target as HTMLElement,
                ref.current as unknown as HTMLElement
            )
        )
            return;
        callback();
    }, []);

    useEffect(() => {
        document.addEventListener("click", clickHandler);
        return () => document.removeEventListener("click", clickHandler);
    }, []);

    function isChildOf(element: HTMLElement, parent: HTMLElement): boolean {
        if (!element.parentElement) return false;
        if (element.parentElement === parent) return true;
        return isChildOf(element.parentElement, parent);
    }

    return ref;
}
